/*global SunergoPlatform,  */
import '../scss/main.scss';

// const bodyScrollLock = require('body-scroll-lock');

const keys = {
	end: 35,
	home: 36,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
	delete: 46,
	enter: 13,
	space: 32
};

// Page Navigation Change Detection
// function initPageNavChange() {
// 	document.querySelectorAll('a').forEach(item => {
// 		item.addEventListener('click', function() {
// 			if (
// 				this.hash == '' &&
// 				(this.target == '' || this.target == '_self') &&
// 				this.hostname != ''
// 			) {
// 				setTimeout(function() {
// 					document.body.classList.remove('is-loaded');
// 				}, 1000);
// 			}
// 		});
// 	});
// }

// Popover Menus
function initPopoverMenus() {
	SunergoPlatform.popoverMenus.initAll();
}

// Navigation Keyboard Controls
// TODO: combine Tabs and Table of Contents controls into one function
// TODO: Use arrow keys for Table of Contents controls

// Tabs
function initTabs() {
	const tabList = document.querySelector('[data-nav-tab="list"]');

	function createTabs(tabList) {
		const tabs = tabList.querySelectorAll('[data-nav-tab="item"]');

		function addListeners(index) {
			tabs[index].addEventListener('keydown', keydownEventListener);
			tabs[index].addEventListener('keyup', keyupEventListener);

			tabs[index].index = index;
		}

		function keydownEventListener(event) {
			const key = event.keyCode;

			switch (key) {
				case keys.up:
				case keys.down:
					event.preventDefault();
					break;

				case keys.end:
					event.preventDefault();
					focusLastTab();
					break;

				case keys.home:
					event.preventDefault();
					focusFirstTab();
					break;
			}
		}

		function keyupEventListener(event) {
			const key = event.keyCode;

			switch (key) {
				case keys.up:
				case keys.down:
				case keys.left:
				case keys.right:
					switchTabOnArrowPress(event);
					break;
			}
		}

		function switchTabOnArrowPress(event) {
			const pressed = event.keyCode;
			const target = event.target;
			let direction = 1;

			if (target.index !== undefined) {
				if (pressed == keys.left || pressed == keys.up) direction = -1;

				const nextTab = tabs[target.index + direction];
				if (nextTab) nextTab.focus();
				else if (pressed == keys.left) focusFirstTab();
				else if (pressed == keys.right) focusLastTab();
			}
		}

		function focusFirstTab() {
			tabs[0].focus();
		}

		function focusLastTab() {
			tabs[tabs.length - 1].focus();
		}

		for (let i = 0; i < tabs.length; i++) addListeners(i);
	}

	if (tabList) createTabs(tabList);
}

// ScrollSpy for Table of Contents tracking
function initContentNav() {
	const options = {
		rootMargin: '-33% 0px 0px',
		threshold: 0
	};
	const contentNav = '[data-nav-content]';

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const id = entry.target.getAttribute('id');
			let item = document.querySelectorAll(`[data-nav-content-id="${id}"]`);

			if (item.length != 1)
				console.warn(
					'[Content Nav] Duplicate section IDs found. This will cause issues with section jumping and current section indicator.',
					id
				);
			item = item[0];

			// if a TOC item matches the id that is visible
			if (item && id) {
				const isVisible = entry.isIntersecting;

				// save the visibility status
				item.dataset.navContentVisible = isVisible;

				// if not visible, then set inactive
				if (!isVisible) item.dataset.navContentActive = false;

				// look through all visible, and set first one to active
				const visible = document.querySelectorAll('[data-nav-content-visible="true"]');
				for (let i = 0; i < visible.length; i++)
					visible[i].dataset.navContentActive = i == 0;
			}
		});
	}, options);

	// Track all sections that have an `id` applied, when there is more than 1 section.
	const sections = document.querySelectorAll('[data-content-nav] > [data-content-section][id]');
	if (sections.length > 1) {
		sections.forEach(section => {
			observer.observe(section);
		});

		const contentNavToggle = document.querySelectorAll('[data-action="content-nav-toggle"]');
		if (contentNavToggle) {
			const contentNavArea = document.querySelector(contentNav);

			window.addEventListener('click', function(event) {
				const currNavArea = document.querySelector(contentNav);

				const isOpen = currNavArea.dataset.navContentOpen;

				// close toc nav when it is open, and the target is not a link or inside the nav or the close button
				if (isOpen && event.target != currNavArea) {
					currNavArea.dataset.navContentOpen = false;
					if (!currNavArea.contains(event.target)) event.preventDefault();
				}
			});
			Array.prototype.forEach.call(contentNavToggle, function(item) {
				item.addEventListener('click', function(event) {
					contentNavArea.dataset.navContentOpen = !contentNavArea.dataset.navContentOpen;

					if (contentNavArea.dataset.navContentOpen) {
						contentNavArea.getElementsByTagName('a')[0].focus();
					}
					event.stopImmediatePropagation();
				});
			});
		}
	}
}

function initStickyStuckDetection() {
	const stickyMenu = document.querySelector('[data-app-menu="fixed"]');
	const topMargin = stickyMenu ? stickyMenu.offsetHeight : 0;
	const bottomMargin = 0;
	const rootMargin = `-${parseFloat(topMargin) + 1}px 0px ${parseFloat(bottomMargin) - 1}px 0px`;

	const observer = new IntersectionObserver(
		(events) => {
			events.forEach(e => e.target.dataset.sticky = e.intersectionRatio < 1 ? 'floating' : '');
		},
		{
			threshold: [1],
			rootMargin: rootMargin
		}
	);
	document.querySelectorAll('[data-sticky]').forEach(item => observer.observe(item));
}

function initDisclosure() {
	const disclosure = document.querySelectorAll('[data-disclosure]');
	if (disclosure && disclosure.length > 0) {
		Array.prototype.forEach.call(disclosure, function(item) {
			const summary = item.querySelector('summary');
			let animationTimer = null;

			if (!summary) return;
			summary.addEventListener('click', function (event) {
				if (!item.hasAttribute('open')) return;
				event.preventDefault();
				item.setAttribute('data-closing', true);
				clearTimeout(animationTimer);

				animationTimer = setTimeout(function() {
					item.removeAttribute('data-closing');
					item.removeAttribute('open');
				}, 200);
			});
		});
	}
}

// Run scripts on document loaded
SunergoPlatform.onLoad.push(
	// initPageNavChange();
	initPopoverMenus,
	initTabs,
	initContentNav,
	initStickyStuckDetection,
	initDisclosure
);

// Run all functions that are needed to run on load.
document.addEventListener('DOMContentLoaded', function() {
	const jsFunctions = SunergoPlatform.onLoad;

	for (let i = 0; i < jsFunctions.length; i++) {
		try {
			jsFunctions[i]();
		} catch (e) {
			console.error('[Sunergo Platform] Error running onLoad function:\n', e);
			continue;
		}
	}
	SunergoPlatform.loading.remove('global-setup');
	document.body.classList.remove('js-css-preload');
});
